import { useEffect } from 'react';
import classes from './transactions.module.scss'
function Transactions() {
    const r2BaseUrl = process.env.REACT_APP_R2_BASE_URL
    useEffect(() => {
        window.onmessage = function(e) { // inside the parent
            try {
                const data = JSON.parse(e.data)
                if(data.url) {
                    window.open(data.url, '_blank')
                }
            } catch (error) {
                console.log(error)
            }
        };
    }, [])
    // const r2BaseUrl = 'http://localhost:3000'
    return (
        <div className={classes.container}>
            <iframe
                allow="autoplay; encrypted-media"
                className={classes.iframeContainer}
                sandbox="allow-scripts allow-same-origin"
                frameBorder="0"
                src={`${r2BaseUrl}/transactions`} title="Embedded Content" width="100%" height="700" />
        </div>
    );
}

export default Transactions;